import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root',
  })
  export class UserStateService {
    public isDataAvailable: BehaviorSubject<boolean>=new BehaviorSubject<boolean>(true);
    public isNetworkAvailable: BehaviorSubject<boolean>=new BehaviorSubject<boolean>(true);
    public isApolloAvailable: BehaviorSubject<boolean>=new BehaviorSubject<boolean>(true);
  
    constructor() {
    }
  }